
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getAbExperiments",
      resolverType: "query",
      routePath: "/getAbExperiments",
      httpMethod: "POST",
    });
  